import React, { useState, createContext, useEffect } from 'react';
import { useHostPath } from './Hooks/useHostPath';

export interface AuthConfiguration {
  clientId?: string;
  authority?: string;

  baseUrl?: string;
  hostPath?: string;
  scope?: string;
}

const defaultContextValue: AuthConfiguration = {
  clientId: '',
  authority: '',
  baseUrl: '',
  hostPath: '',
  scope: ''
};

export const AuthConfigurationContext = createContext<AuthConfiguration>(defaultContextValue);

interface AuthConfigContextProps {
  children: JSX.Element;
}

export const AuthConfigurationProvider = (props: AuthConfigContextProps): JSX.Element => {
  const { children } = props;

  const [settings, setSettings] = useState<AuthConfiguration>({});

  useEffect(() => {
    fetch(useHostPath('api/Auth'))
      .then((response) => response.json())
      .then((json) =>
        setSettings((s) => ({
          ...s,
          ...json,
          hostPath: useHostPath(),
          ...{ baseUrl: useHostPath('api') }
        }))
      );
  }, []);

  const conditionallyRenderChildren = () => {
    // Only render children after AuthConfiguration has been fetched:
    if (Object.keys(settings)?.length > 0) {
      return children;
    }
    return <></>;
  };

  return (
    <AuthConfigurationContext.Provider value={settings}>
      {conditionallyRenderChildren()}
    </AuthConfigurationContext.Provider>
  );
};
